import { Link } from "react-router-dom";
import { comics, featuredIds } from "@/mocks/comics";
import ComicCard from "@/components/feature/ComicCard";
import SectionHeader from "@/components/feature/SectionHeader";

function Featured() {
  const list = comics.filter((c) => featuredIds.includes(c.id));

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
      <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
        <SectionHeader
          eyebrow="Signature Selection"
          title="尊享典藏 · 殿堂级推荐"
          desc="精挑细选的高分神作，超高画质与完整剧情并重，为尊贵会员呈现不可错过的典藏佳作。"
        />
        <Link
          to="/category"
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-300 hover:text-primary-200 transition cursor-pointer"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 lg:grid-cols-6">
        {list.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}

export default Featured;